try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { Container } from '@design-system/container';
import { CountryPicker } from '@design-system/country-picker';
import { Link } from '@design-system/link';
import { Section } from '@design-system/section';
import { Typography } from '@design-system/typography';
import { forwardRef } from 'react';
import { Icon } from '@design-system/icon';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var classnames = {exports: {}};

(function (module) {
  /* global define */
  (function () {

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = _typeof(arg);

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);

var classNames = classnames.exports;

const MedicalAddon = ({ medicalAddon }) => (jsx("div", Object.assign({ className: "cds-medical-addon" }, { children: jsx(Container, Object.assign({ maxWidth: "max-grid" }, { children: medicalAddon.map(({ icon, description }) => {
            const IconComponent = (icon === null || icon === void 0 ? void 0 : icon.component) || Icon;
            return (jsxs("div", Object.assign({ className: "cds-medical-addon__item" }, { children: [icon.props && jsx(IconComponent, Object.assign({}, icon.props, { size: 40 })), jsx("div", Object.assign({ className: "cds-mediacal-addon__description" }, { children: description }))] }), description));
        }) })) })));

const FooterBasic = forwardRef(({ className, mode = 'default', LinkNavElement = Link, navigationData, disclaimer, copyright, iconsData, iconsHeading, uid, medicalAddon, countryPicker, isCookieModal, cookieButtonText, privacyNoteText, }, ref) => (jsxs(Fragment, { children: [(medicalAddon === null || medicalAddon === void 0 ? void 0 : medicalAddon.length) ? (jsx(MedicalAddon, { medicalAddon: medicalAddon })) : null, jsx(Section, Object.assign({ ref: ref, mode: mode, element: "footer", className: className, removeAllSpacing: true, "data-component-uid": uid }, { children: jsxs(Container, Object.assign({ maxWidth: "max-grid", className: "cds-footer" }, { children: [(countryPicker === null || countryPicker === void 0 ? void 0 : countryPicker.currentCountry) && (jsx(CountryPicker, Object.assign({}, countryPicker))), jsxs("ul", Object.assign({ className: "cds-footer__nav-list" }, { children: [navigationData.map((_a) => {
                                var { href, variant = 'subtle', size = 'large' } = _a, props = __rest(_a, ["href", "variant", "size"]);
                                return (jsx("li", { children: jsx(LinkNavElement, Object.assign({ variant: variant, href: href, size: size }, props)) }, href));
                            }), isCookieModal && cookieButtonText ? (jsx("li", { children: jsx(Button, Object.assign({ id: "ot-sdk-btn", className: "cds-btn cds-btn--subtle ot-sdk-show-settings", "aria-label": "open cookie preferences modal" }, { children: cookieButtonText })) })) : null] })), isCookieModal && privacyNoteText ? (jsx("div", Object.assign({ className: "cds-footer__privacy-notice" }, { children: jsx(Typography, { className: "cds-footer__copyright", content: privacyNoteText, variant: "body", size: "xs" }) }))) : null, jsxs("div", Object.assign({ className: "cds-footer__social" }, { children: [copyright && (jsx(Typography, { className: "cds-footer__copyright", content: copyright, variant: "body", size: "xs" })), !!(iconsData === null || iconsData === void 0 ? void 0 : iconsData.length) && (jsxs("div", Object.assign({ className: "cds-footer__social-links" }, { children: [iconsHeading && (jsx(Typography, Object.assign({}, iconsHeading, { className: classNames(iconsHeading.className, 'cds-footer__social-heading'), id: "social-networks-label-id" }))), jsx("ul", Object.assign({ "aria-labelledby": "social-networks-label-id", className: "cds-footer__icon-list" }, { children: iconsData.map((_a) => {
                                            var { href, variant = 'subtle-icon', size = 'small' } = _a, props = __rest(_a, ["href", "variant", "size"]);
                                            return (jsx("li", { children: jsx(LinkNavElement, Object.assign({ className: "cds-footer__icon-list-item", variant: variant, href: href, size: size }, props)) }, href));
                                        }) }))] })))] })), disclaimer && (jsx("div", Object.assign({ className: "cds-footer__disclaimer" }, { children: jsx(Typography, { className: "cds-footer__disclaimer-content", content: disclaimer, variant: "body", size: "s" }) })))] })) }))] })));

const FooterWithSplitter = forwardRef(({ className, uid, mode = 'default', splitter, medicalAddon }, ref) => (jsxs(Fragment, { children: [(medicalAddon === null || medicalAddon === void 0 ? void 0 : medicalAddon.length) ? jsx(MedicalAddon, { medicalAddon: medicalAddon }) : null, jsx(Section, Object.assign({ ref: ref, mode: mode, element: "footer", className: className, removeAllSpacing: true, "data-component-uid": uid }, { children: jsx(Container, Object.assign({ maxWidth: "max-grid", className: "cds-footer" }, { children: splitter })) }))] })));

const isWithSplitter = (props) => !!props.splitter;
const Footer = (props) => isWithSplitter(props) ? (jsx(FooterWithSplitter, Object.assign({}, props))) : (jsx(FooterBasic, Object.assign({}, props)));

export { Footer };
